import type { GetServerSideProps } from 'next';
import feature_sale from '../../../public/images/feature_sale_2025.png';
import { createFeatureNamePage } from '../../features/featurePages/featureNameTemplate';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

export const getServerSideProps: GetServerSideProps<CommonFeatureSSRProps> =
  async (ctx) => {
    const { commonFeatureGetServerSideProps } = await import(
      '../../server/features/commonFeatureServerSideProps'
    );
    return commonFeatureGetServerSideProps(ctx);
  };

export default createFeatureNamePage({
  slug: 'sale',
  featureName: 'セール',
  title: '年末・初売りセールメニュー一覧',
  description: 'あの占い師も新春特価で試せる！期間限定のセールメニュー特集',
  ogImageUrl: 'https://raysee.jp/images/feature_sale_ogp_2025.png',
  heroImage: feature_sale,
});
